import { MoonLandingIcon } from '@hugeicons-pro/core-solid-rounded'

import { HugeiconsIcon } from '@hugeicons/react'

import { useLevelContext } from '@/features/level-play'
import { Step, useFlow } from '@/shared/lib/steps-flow'
import { Button } from '@/shared/ui/Button'
import { getIcon, StageText } from '@/shared/ui/Icons'
import { PointsScoreboard } from '@/shared/ui/PointsScoreboard'

import { HUD } from './HUD'

interface StepInitialProps {
  step: Step
}

export const StepInitial = ({ step }: StepInitialProps) => {
  const { level, levelProgress, resumeStepIndex } = useLevelContext()
  const { hasChallengeToContinue } = levelProgress
  const Icon = getIcon(level?.icon) || StageText

  const { state, goNext, goIndex } = useFlow()
  const { lives } = state

  // "Continuar" trocava só o rótulo e ia para o passo 1: o aluno refazia tudo
  // desde o começo e, numa jornada com block_redo, batia em `challenge_done` no
  // primeiro desafio já respondido. Agora ele volta para onde parou de fato.
  const handleStart = () => {
    if (resumeStepIndex > 0) {
      goIndex(resumeStepIndex)
      return
    }

    goNext()
  }

  return (
    <HUD.Card>
      <HUD.Header>Preparado?</HUD.Header>
      <HUD.Body className="flex flex-col items-center justify-center gap-6 row-span-2">
        <div className="flex flex-col items-center justify-center gap-4 p-6 rounded-2xl bg-jacaranda/20 w-full max-w-xl">
          <HugeiconsIcon
            icon={MoonLandingIcon}
            size={70}
            className="text-jacaranda"
          />
          <span className="font-semibold text-center text-foreground text-md sm:text-lg md:text-2xl block max-w-[400px]">
            Você possui{' '}
            <span className="text-tie">
              {lives} vida{lives == 1 ? '' : 's'}
            </span>{' '}
            para completar{' '}
            <span className="text-jacardanda">
              {level?.active_challenges.length} desafio
              {level?.active_challenges.length == 1 ? '' : 's'}
            </span>{' '}
            e {level?.active_challenges.length == 1 ? 'pode' : 'alguns podem'}{' '}
            ter tempo, fique atento!
          </span>
        </div>
        <div className="flex flex-col items-center justify-center p-3 text-muted rounded-2xl bg-jacaranda/20 max-w-xl w-full">
          {level && (
            <div className="flex flex-col sm:flex-row items-center justify-center w-full gap-3 font-normal">
              <Icon className="hidden sm:block" />
              <div className="flex-1 min-w-0">
                <span className="font-semibold text-gray-800 text-md sm:text-lg block">
                  {level.name}
                </span>
                <div className="flex flex-wrap font-semibold text-xs gap-4">
                  <PointsScoreboard
                    className="mb-2"
                    acquiredPoints={levelProgress.rewards.acquiredPoints}
                    totalPoints={
                      levelProgress.rewards.totalPoints ||
                      level.total_point_reward ||
                      0
                    }
                  />
                  <span className="flex items-center mb-2 text-gray-400 gap-2">
                    <img src="/icons/coin.svg" alt="" className="size-6" />
                    <span className="text-lg font-sans text-dark">
                      {level.total_coin_reward || 0}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      </HUD.Body>
      <HUD.Footer id={step.id}>
        {/* {!journeyBlockRedo && hasChallengeToContinue && (
          <Button type="button" onClick={onLevelReset} variant="primary">
            Recomeçar
          </Button>
        )} */}
        <Button
          type="button"
          variant="success"
          className="flex-1 font-semibold"
          onClick={handleStart}
        >
          {hasChallengeToContinue ? 'Continuar' : 'Começar'}
        </Button>
      </HUD.Footer>
    </HUD.Card>
  )
}
